// Copyright (c) 2025 Audere, All Rights Reserved

import { Navigate, Outlet, useLocation } from "react-router";
import { selectCurrentToken, selectIsLoggedOut } from "../features/auth/authSlice";

import { useSelector } from "react-redux";
import NotFound from "../screens/NotFound";

const RequireAuth = () => {
  const isLoggedIn = !!useSelector(selectCurrentToken);
  const isLoggedOut = useSelector(selectIsLoggedOut);
  const location = useLocation();

  return isLoggedIn ? (
    <Outlet />
  ) : isLoggedOut ? (
    <Navigate to="/" state={{ from: location }} replace />
  ) : (
    <NotFound />
  );
};

export default RequireAuth;
